import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { MOAT, DEMO_URL } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
export function MoatSection() {
  return <section id="intelligence" aria-labelledby="moat-heading" className="relative overflow-hidden border-b border-hairline-soft bg-surface" data-id="element-221" data-mp="1v5lnu7oeh21t">
      <div className="sf-dot-texture pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-222" data-mp="29wch7k5n4971" />
      <div className="relative mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-223" data-mp="24xhnhn64x085">
        <SectionHeading eyebrow="The Intelligence Moat" headingId="moat-heading" size="lg" title={<>
              You Can Build the Interface.
              <br data-id="element-225" data-mp="oiq4g0uvp5bi" />
              <em data-id="element-226" data-mp="ji25mt0erk6q">You Can&apos;t Vibe-Code the Intelligence.</em>
            </>} data-id="element-224" data-mp="2isk2czsylzx3" />

        <div className="mt-14 grid gap-4 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]" data-id="element-227" data-mp="1j05v3a675ua2">
          <Reveal className="rounded-2xl border border-hairline bg-panel/60 p-6 sm:p-8" data-id="element-228" data-mp="1nz0d49wcbet4">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-text-tertiary" data-id="element-229" data-mp="1sy3gzr0l3ezi">
              Generic AI can
            </h3>
            <ul className="mt-6 flex flex-col gap-3.5" data-id="element-230" data-mp="1xpv6rzbx1gol">
              {MOAT.generic.map(item => <li key={item} className="flex items-start gap-3 text-sm text-text-secondary" data-id="element-231" data-mp="21plutva25ipf">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-text-tertiary" aria-hidden="true" data-id="element-232" data-mp="26ogl1iacu9jk" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 border-t border-hairline-soft pt-5 text-xs text-text-tertiary" data-id="element-233" data-mp="2gnxrw31ceth4">
              Increasingly a commodity — available to every fund.
            </p>
          </Reveal>

          <Reveal delay={0.08} className="relative overflow-hidden rounded-2xl border border-[#E3DFF4] bg-[#FBFAFF] p-6 shadow-[0_24px_60px_-40px_rgba(32,22,95,0.35)] sm:p-8" data-id="element-234" data-mp="m950yhbemqvi">
            <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full" style={{
            background: 'radial-gradient(circle, rgba(32,22,95,0.06), transparent 65%)'
          }} data-id="element-235" data-mp="9axh77yykw4a" />
            <div className="relative flex items-center justify-between gap-3" data-id="element-236" data-mp="x7tcau4grhs8">
              <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-lime" data-id="element-237" data-mp="x5qdbklc2ebd">
                DiligenceGPT adds
              </h3>
              <span className="rounded-md border border-lime/30 bg-lime/10 px-2 py-1 text-[10px] font-medium uppercase tracking-wider text-lime" data-id="element-238" data-mp="16xw62wjeszrm">
                Proprietary
              </span>
            </div>
            <ul className="relative mt-6 grid gap-3.5 sm:grid-cols-2" data-id="element-239" data-mp="1fzcewzuksttq">
              {MOAT.dgpt.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium text-text-primary" data-id="element-240" data-mp="1byae4el0g9pn">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-lime/15" data-id="element-241" data-mp="1ulsyf0xerlkp">
                    <CheckIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-242" data-mp="1zhqhhf023616" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-14 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-end" data-id="element-243" data-mp="1bus44q78ge7h">
          <div data-id="element-244" data-mp="1glrwdi5eq83n">
            <p className="sf-display text-[28px] leading-[1.1] text-text-primary sm:text-[36px]" data-id="element-245" data-mp="1gma2d6hvg0or">
              AI is becoming a commodity.
              <br data-id="element-246" data-mp="12rqzyv1xgx6g" />
              <em data-id="element-247" data-mp="16vf7xeuh1us8">Proprietary intelligence is not.</em>
            </p>
          </div>
          <div className="flex flex-col items-start gap-6" data-id="element-248" data-mp="16t2osycz9edl">
            <p className="text-[15px] leading-relaxed text-text-secondary" data-id="element-249" data-mp="swyyhg585q6e">
              DiligenceGPT combines foundation models with structured venture intelligence that
              continues growing as startups, funds, investment theses, ecosystems and investment
              workflows enter the network.
            </p>
            <CtaButton href={DEMO_URL} event="moat_cta_click" size="lg" data-id="element-250" data-mp="1w8o6itgdfvu0">
              See DiligenceGPT on Your Fund
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-251" data-mp="1mgrwck10gf9f" />
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>;
}